// extracted by mini-css-extract-plugin
export default {"container":"EmptyStateImage_container__+ah0A"};